import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: '40rem',
  overflow: 'hidden',
}))
